@if (loading()) {
    <div class="loading-container" [class.fixed]="fixed()"><ng-content></ng-content></div>
}
